import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
  overflow-y: auto;
`;

export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1.25rem;
`;

export const CKGridRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
`;

export const FileInput = styled.input`
  width: 0;
  visibility: hidden;
  height: 0;
`;

export const FileInputLabel = styled.label`
  width: auto;
  color: #1bace4;
  font-family: "Lato";
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
  text-align: center;
  text-align: left;
`;

export const FileImageWrapper = styled.label`
  margin-top: 10px;
  border-radius: 40px;
  margin-left: 10px;
`;

export const TextInputLabel = styled.label`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 1;
  color: #1bace4;
  position: absolute;
  text-transform: initial;
  left: 0.625rem;
  top: 0.625rem;
  z-index: 1;
  width: auto;
  transition: transform 150ms ease-out, font-size 150ms ease-out;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;

export const CKInputLabel = styled.label`
  width: auto;
  color: #1bace4;
  font-family: "Lato";
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
  text-align: center;
  text-align: left;
  margin-top: 10px;
  &::after {
    content: "*";
    color: #ea6457;
    font-weight: bold;
  }
`;

export const FileName = styled.p`
  line-height: 2;
  color: #084987;
  position: absolute;
  top: -30px;
  position: relative;
  margin: 0;
  font-family: "Lato";
  font-size: 14px;
`;

export const RequiredMessage = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  padding: 0;
`;

export const DocumentRow = styled.div`
  margin-top: 40px;
`;

export const AddForm = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  margin: 1.75rem 0 0 0;
  align-items: end;
`;

export const DeleteSpan = styled.span`
  border-radius: 40px;
  width: auto;
  margin-left: 7px;
`;
